'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../~/shortid/index.js
// module id = 19
// module chunks = 0